// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"2cec86e9","453":"ca364910","916":"b7eaa0b3"}[chunkId] + ".chunk.js";
};